<template>
  <div id="myorder">
    <div class="box-top">
      <p class="title ft16 f-b">订单详情</p>
      <ul class="order-tit order-row">
        <li v-if="datas.status == 0">
          <span class="theme-col">待支付</span>
        </li>
        <li v-if="datas.status == 1">
          <span class="theme-col">待发货</span>
        </li>
        <li v-if="datas.status == 2">
          <div v-if="datas.refund_status" class="pay_status">
            {{ datas.refund_status == 1 ? '部分退款' : '全部退款' }}
          </div>
          <div class="pay_status" v-else>部分发货</div>
          <!-- <span class="theme-col">部分发货</span> -->
        </li>
        <li v-if="datas.status == 3">
          <div v-if="datas.refund_status" class="pay_status">
            {{ datas.refund_status == 1 ? '部分退款' : '全部退款' }}
          </div>
          <div class="pay_status" v-else>已发货</div>
        </li>
        <li v-if="datas.status == 4">
          <span class="theme-col">交易关闭</span>
        </li>
        <li v-if="datas.status == -1">
          <span class="theme-col">已取消</span>
        </li>
      </ul>
      <div class="dingdanzt" v-if="datas">
        <div>
          <span>订单号：{{ datas.ordersn }}</span
          >&nbsp;&nbsp;&nbsp;&nbsp;
          <span>下单时间：{{ times(datas.order_time) }}</span>
        </div>
        <div>
          <div
            class=" bottom-g"
            style="width: 110px;font-size:14px;text-align:center;height: 36px;line-height:36px;background: #FFFFFF;border-radius: 6px;border: 1px solid #BEBEBE;"
            v-if="datas.is_cancel > 0"
            @click="cancel(datas.id_order, datas.is_cancel)"
          >
            取消订单
          </div>
          <div
            class=" bottom-g"
            style="width: 110px;font-size:14px;text-align:center;height: 36px;line-height:36px;background: #FFFFFF;border-radius: 6px;border: 1px solid #BEBEBE;"
            v-if="datas.status == -1"
            @click="deleteorder(datas.id_order)"
          >
            删除订单
          </div>
          <div
            v-if="datas.status == 0"
            style="width: 110px;font-size:14px;text-align:center;height: 36px;line-height:36px;border-radius: 6px;color:#fff"
            class=" theme-bd  theme-bg bottom-g"
            @click="payfor(datas.id_order)"
          >
            立即支付
          </div>
        </div>
      </div>
    </div>
    <div class="order-list">
      <ul class="order-th order-row">
        <li>收货人信息</li>
      </ul>
      <div class="orders">
        <table class="order-table">
          <tr>
            <ul style="padding-bottom:20px;">
              <li v-if="datas.province != ''" style="padding-top:20px;">
                <span>收货人：</span>{{ datas.consignee }} {{ datas.mobile }}
              </li>
              <li v-if="datas.province != ''">
                <span>收货地址：</span>{{ datas.province }} {{ datas.city }}
                {{ datas.country }} {{ datas.town }} {{ datas.address }}
              </li>
              <li v-if="datas.province != ''">
                <span>备注：</span>{{ datas.memo }}
              </li>
              <li v-if="datas.province == ''">
                <span>收货人手机：</span>{{ datas.mobile }}
              </li>
            </ul>
          </tr>
        </table>
      </div>
      <!-- <p class="title ft16 f-b" style="padding-bottom: 10px;">商品信息</p> -->
      <ul class="expressr-th">
        <li style="padding-left:30px;box-sizing:border-box;">商品物流信息</li>
        <li>单价</li>
        <li>数量</li>
        <li>状态</li>
        <li>操作</li>
      </ul>
      <div
        class="orders"
        v-for="(items, index) in products"
        :key="items.code"
        style="margin-bottom:0"
        v-if="datas != ''"
      >
        <!--  v-if="items[0].express_num != ''" -->
        <div
          class="ydh"
          style="line-height:38px;border-top:none;border-bottom:none;padding-left:30px"
          v-if="items[0].express_num != ''"
        >
          <div>
            <span>运单号：{{ items[0].express_num }}</span
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>物流公司：{{ items[0].express_name }}</span>
          </div>
        </div>
        <!-- <div
          style="line-height:38px;border: 1px solid #e3e3e3;border-top:none;border-bottom:none;padding-left:30px"
          v-if="items[0].express_num == ''&&items[0].source!=3&&items[0].source!=2"
        >暂无发货信息</div> -->
        <table class="order-table" style="padding-left: 30px;">
          <tr v-for="(item, i) in items">
            <td
              class="product-img"
              style="width: 15%;text-align: left;padding-left: 30px;"
            >
              <router-link
                tag="a"
                target="_blank"
                :to="{ name: 'Detail', params: { id: item.m_id } }"
              >
                <img
                  v-lazy="item.img"
                  onerror="src='/static/imgout2.png'"
                  alt
                />
              </router-link>
            </td>
            <td style="width: 25%;text-align: left;">
              <router-link
                tag="a"
                target="_blank"
                :to="{ name: 'Detail', params: { id: item.m_id } }"
              >
                <div class="product-name">
                  <span class="jd" v-show="items.source == 1">优选</span>
                  <span class="yx" v-show="items.source == 6">严选</span>
                  <span class="new" v-show="items.source == 2">直充</span>
                  <span class="rob" v-show="items.source == 3">卡券</span>
                  {{ item.name }}
                </div>
              </router-link>
            </td>
            <td style="width: 15%">
              <span v-if="Number(item.points)">
                {{ item.points }}
                <span style="color:#868686;">{{ $store.state.name }}</span>
              </span>
              <span v-if="item.cash && item.cash != 0">
                <span v-if="Number(item.points)">+</span>{{ item.cash }}元
              </span>
            </td>
            <td style="width: 15%">{{ item.nums }}</td>
            <td
              style="width: 15%"
              v-if="item.express_id != 0 && i == 0"
              :rowspan="items.length"
            >
              已发货
            </td>
            <td
              style="width: 15%"
              v-if="item.express_id == 0 && i == 0"
              :rowspan="items.length"
            >
              未发货
            </td>
            <td style="width: 15%" :rowspan="items.length" v-if="i == 0">
              <!-- v-if="item.express_id!=0" -->
              <span
                v-if="item.express_id != 0"
                @click="showExpress(item.express_id, index)"
                style="color: #4478D6;"
              >
                查看物流
                <i
                  class="el-icon-caret-bottom"
                  :class="kuaidi[index].show ? 'rotate' : 'r'"
                  v-if="kuaidi[index] != undefined"
                ></i>
                <i
                  class="el-icon-caret-bottom r"
                  v-if="kuaidi[index] == undefined"
                ></i>
              </span>
            </td>
          </tr>
        </table>

        <transition
          name="fade"
          v-if="shua && kuaidi[index] != undefined && kuaidi[index].show"
        >
          <vTimeline
            style="padding: 10px 20px;
    box-sizing: border-box;border:1px solid #e3e3e3;border-top:none；background：#fff;"
            v-show="kuaidi[index].show"
            :datas="kuaidi[index].info"
            :nodata="nodata"
          ></vTimeline>
        </transition>
      </div>
      <div class="total1">
        <div class="tt">
          <div>
            <span class="total1name">商品数量：</span>
            <span class="totalnum">{{ nums }}件</span>
          </div>
          <div>
            <span class="total1name">商品总额：</span>
            <span class="totalnum">
              <span v-if="datas.totalPoints"
                >{{ datas.totalPoints }} {{ $store.state.name }}</span
              >
              <span v-if="datas.total_cash && datas.total_cash != 0">
                <span v-if="datas.totalPoints">+</span>{{ datas.total_cash }}元
              </span>
            </span>
          </div>
          <div>
            <span
              class="total1name"
              style="display: inline-block;height:40px;line-height:50px;"
            >
              应付总额：
            </span>
            <span class="totalnum ">
              <span v-if="datas.totalPoints">
                <span class="lager">{{ datas.totalPoints }}</span>
                {{ $store.state.name }}
              </span>
              <span v-if="datas.total_cash && datas.total_cash != 0">
                <span class="lager" v-if="datas.totalPoints">+</span>
                <span class="lager">{{ datas.total_cash }} </span>元
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="total">
        共计
        <span class="theme-col">{{nums}}&nbsp;</span>件商品&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合计：
        <span class="theme-col">{{datas.totalPoints}}</span>
        <span style="color:#868686;">{{$store.state.name}}</span>
      </div> -->
      <!-- <div class="btns" style="overflow: hidden;margin-top: 30px;">

        <div
          class="theme-bd"
          v-if="datas.is_cancel>0"
          @click="cancel(datas.id_order,datas.is_cancel)"
        >取消订单</div>
        <div class v-if="datas.status==-1" @click="deleteorder(datas.id_order)">删除订单</div>
     <div class="theme-bg theme-bd" v-if="datas.status==0" @click="payfor(datas.id_order)">立即支付</div>

      </div> -->
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-row
        style="width:562px;    display: flex;
    margin: 0 auto; align-items: center;padding-bottom:80px"
      >
        <el-col style="padding-right:57px;">
          <canvas
            id="paycanvas"
            width="182px"
            style="width:182px;border: 1px solid #C7C7C7;"
          ></canvas>
          <br />
          <div
            style="width: 182px;height: 48px;background: rgb(226, 49, 48);display: flex;justify-content: space-between;color: #fff; padding: 10px 15px;box-sizing: border-box;align-items: center;"
          >
            <img style="width:24px;height:24px;" src="/static/img/sm.png" />
            <p style="color:#fff;font-size: 13px;line-height:17px;width:104px">
              请使用微信扫一扫 扫描二维码支付
            </p>
          </div>
        </el-col>
        <el-col>
          <img style="width:320px;" src="/static/img/phone.png" alt />
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import vTimeline from "@/common/timeline";
import pay from "@/mixins/pay.js";
export default {
  name: "",
  mixins: [pay],
  data() {
    return {
      id_order: this.$route.params.id,
      status: this.$route.params.status,
      datas: "",
      nums: 0,
      reverse: true,
      products: "",
      kuaidi: [],
      nodata: "暂无物流信息",
      shua: false
    };
  },
  components: {
    vTimeline
  },
  methods: {
    //订单详情
    getDota() {
      var _this = this;
      this.$api.get(
        "order/orders/details",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_order: this.id_order,
          status: this.status
        },
        res => {
          if (res.data.code == 100) {
            this.datas = res.data.data;
            this.products = res.data.data.products;
            this.products = this.changeProducts(this.products);
            $.each(res.data.data.products, function(index, items) {
              _this.nums += parseInt(items.nums);
            });
          } else {
            this.$message({
              message: res.data.message,
              duration: 1500,
              center: true
            });
            history.go(-1);
          }
        }
      );
    },
    times(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m;
      if (date.getMinutes() < 10) {
        m = "0" + date.getMinutes() + ":";
      } else {
        m = date.getMinutes() + ":";
      }
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    //快递接口
    getexpress(id, index) {
      this.$api.get(
        "order/orders/logistics",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          company_id: id
        },
        res => {
          if (res.data.code == 100) {
            this.shua = false;
            this.$nextTick(() => {
              this.kuaidi[index] = { info: res.data.data.item, show: true };
              console.log(this.kuaidi[index]);
              this.shua = true;
            });
          } else {
            this.$message({
              message: res.data.message,
              duration: 1500,
              center: true
            });
          }
        }
      );
    },
    showExpress(id, index) {
      if (this.kuaidi[index] == undefined) {
        this.getexpress(id, index);
      } else {
        this.shua = false;
        this.$nextTick(() => {
          this.shua = true;
          this.kuaidi[index].show = !this.kuaidi[index].show;
        });
      }

      // this.kuaidi[index].show = !this.kuaidi[index].show;
    },
    //去支付
    payfor(order) {
      this.$confirm("确定支付该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.wxPay(order);
        })
        .catch(() => {});
    },
    cancel(id, type) {
      this.$api.post(
        "order/orders/cancel",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_order: id,
          type: type
        },
        res => {
          if (res.data.code == 100) {
            this.$message({
              message: "取消成功",
              duration: 1500,
              center: true
            });
            this.getDota();
          }
        }
      );
    },
    //删除订单
    deleteorder(id) {
      this.$api.post(
        "order/orders/delete",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_order: id
        },
        res => {
          if (res.data.code == 100) {
            this.$message({
              message: "删除成功",
              duration: 1500,
              center: true
            });
            this.$router.push({ name: "Orderlist" });
          }
        }
      );
    },
    changeProducts(products) {
      var pro = {};
      for (var p in products) {
        var express_num = products[p].express_num;
        console.log(express_num);
        if (pro[express_num] == undefined) {
          pro[express_num] = [products[p]];
        } else {
          pro[express_num].push(products[p]);
        }
      }
      return pro;
    }
  },
  mounted() {
    this.getDota();
  }
};
</script>
<style lang="less" scoped>
.total1 {
  display: flex;
  padding-top: 15px;
  justify-content: flex-end;
  background: #fff;
  padding-right: 45px;
  padding-bottom: 35px;
  border-bottom: solid 1px #efefef;
  border: solid 1px #dbdbdb;
  border-top: none;

  .tt {
    min-width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    div {
      display: flex;
      justify-content: space-between;
      padding-top: 10px;
    }
  }
  .total1name {
    height: 17px;
    font-size: 13px;
    font-family: MicrosoftYaHei;
    color: #272727;
    line-height: 17px;
    white-space: nowrap;
  }
  .totalnum {
    height: 17px;
    font-size: 13px;
    font-family: MicrosoftYaHei;
    color: #e23130;
    line-height: 17px;
    white-space: nowrap;
  }
  .lager {
    height: 40px;
    font-size: 30px;
    font-family: MicrosoftYaHei;
    color: #e23130;
    line-height: 40px;
  }
}
.ydh {
  background: #fff;
  border-right: 1px solid #dbdbdb;
  border-left: 1px solid #dbdbdb;
  padding-right: 30px;
  div {
    padding-top: 15px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #e3e3e3;
  }
  span {
    font-size: 12px !important;
  }
}
.box-top {
  background: #fff;
  padding: 14px 30px;
  border-top: solid 4px #e23130;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  .title {
    height: 40px;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 40px;
    padding-bottom: 8px;
    border-bottom: 1px dashed rgba(151, 151, 151, 0.5);
  }
  .order-tit {
    height: 32px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #e23130;
    line-height: 32px;
    padding-top: 15px;
  }
  .dingdanzt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 21px;

    div {
      font-size: 13px;
      font-family: MicrosoftYaHei;
      color: #272727;
      .bottom-g {
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
}
.r {
  transition: all 500ms;
}
.rotate {
  transform: rotate(180deg);
  transition: all 500ms;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.btns {
  div {
    cursor: pointer;
    margin-left: 16px;
    float: right;
    width: 125px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid #d6d6d6;
    font-size: 20px;
  }
}
.col-86 {
  color: #868686;
}
.nopay {
  padding: 3px 10px;
  color: #fff;
  font-size: 12px;
}

#myorder {
  width: 1190px;
  display: inline-block;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);

  .order-list {
    margin-top: 18px;

    .order-tit {
      background: #f3f3f3;
      height: 38px;
      line-height: 38px;
      margin-bottom: 20px;
      li {
        float: left;
        margin-right: 20px;
      }
    }
    .order-th {
      height: 44px;
      line-height: 44px;
      background: #f5f5f5;
      font-size: 15px;
      font-family: MicrosoftYaHei;
      color: #262626;
      border: 1px solid #dbdbdb;
      border-bottom: none;
      li {
        float: left;
      }
      li:nth-child(1) {
        width: 60%;
      }
      li:nth-child(2) {
        text-align: center;
        width: 20%;
      }
      li:nth-child(3) {
        text-align: center;
        width: 20%;
      }
    }
    .expressr-th {
      background: #f3f3f3;
      height: 44px;
      line-height: 44px;
      border: 1px solid #e3e3e3;
      border-bottom: none;
      li {
        float: left;
      }
      li:nth-child(1) {
        width: 40%;
      }
      li:nth-child(2) {
        text-align: center;
        width: 15%;
      }
      li:nth-child(3) {
        text-align: center;
        width: 15%;
      }
      li:nth-child(4) {
        text-align: center;
        width: 15%;
      }
      li:nth-child(5) {
        text-align: center;
        width: 15%;
      }
    }
    .order-row {
      padding-left: 30px;
    }

    .orders {
      margin-bottom: 20px;
      table {
        table-layout: inherit;
        border: 1px solid #dbdbdb;
        border-top: none;
        width: 100%;
        background: #fff;
      }
      td {
        vertical-align: middle;
        color: #353535;
      }
      .product-img {
        padding: 20px 0;
        img {
          width: 90px;
          height: 90px;
        }
      }
      .order-table {
        border-top: none;
        text-align: center;
        ul {
          li {
            padding-left: 30px;
            padding-top: 15px;
            text-align: left;
            span {
              height: 17px;
              font-size: 13px;
              font-family: MicrosoftYaHei;
              color: #7a7a7a;
              line-height: 17px;
              display: inline-block;
              width: 85px;
              text-align: left;
            }
          }
        }
      }
      .order-table:first-child {
        margin-top: 0px;
      }
    }
  }
  .total {
    text-align: right;
    line-height: 58px;
    border: 1px solid #e3e3e3;
    border-top: none;
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/orderdetail.vue